import { render } from "./Paquete.vue?vue&type=template&id=a687433c"
import script from "./Paquete.vue?vue&type=script&lang=js"
export * from "./Paquete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__